module.exports = __webpack_public_path__ + "static/img/icon-eat-type-0.151e92be.png";